module.exports = __webpack_public_path__ + "media/site_templates/www.hirelocalplumbers.com.au/images/feature_1-3e9c30de1f1c0eb9921c16a9ab43d01b.jpeg";